import React from "react";
import { getCouponTypeAnalysis } from "../../Action/courseAction";
import RevenueAnalysisPage from "../Common/RevenueAnalysisPage";
import { EDUTECH, PUBLICATION } from "../Common/revenueAnalysisCommon";

/** resp[0].couponSources → table rows (same field mapping as the old page), highest total first */
const mapCouponRows = (resp, typeId) =>
  (Array.isArray(resp) ? resp[0]?.couponSources || [] : [])
    .map((item) =>
      typeId === EDUTECH
        ? {
            _id: item?.name,
            publication: 0,
            shopifyRevenue: 0,
            edutech: item?.edutechContribution,
            actualTotalAmount: item?.actualAmount,
            totalGstAmount: item?.gstAmount,
            totalAmount: item?.edutech,
          }
        : typeId === PUBLICATION
          ? {
              _id: item?.name,
              publication: item?.publicationContribution,
              edutech: 0,
              shopifyRevenue: 0,
              actualTotalAmount: 0,
              totalGstAmount: 0,
              totalAmount: item?.publication,
            }
          : {
              _id: item?.name,
              publication: 0,
              edutech: 0,
              shopifyRevenue: item?.shopifyRevenue,
              actualTotalAmount: 0,
              totalGstAmount: 0,
              totalAmount: item?.shopifyRevenue,
            },
    )
    .sort((a, b) => (Number(b.totalAmount) || 0) - (Number(a.totalAmount) || 0));

// this page always offered every payment type
const allPaymentTypes = (all) => all || [];

const CouponTypeAnalysis = () => (
  <RevenueAnalysisPage
    pageTitle="COUPON TYPE ANALYSIS"
    chartTitle="Coupon Type Analysis"
    groupLabel="Coupon Type"
    fetchAction={getCouponTypeAnalysis}
    mapRows={mapCouponRows}
    paymentOptionsFor={allPaymentTypes}
    tableId="coupon-type-analysis-table"
  />
);

export default CouponTypeAnalysis;
